export default __webpack_public_path__ + "img/a81d0f19ea55737aa106e1e450227e35.png";